import apiInstance from "@/axios";

const BASE_PATH = "/sub-accounts";

export const subAccountService = {
  async getAvailableCategories() {
    const response = await apiInstance.get(`${BASE_PATH}/available-categories`);
    return response.data;
  },

  async checkUsername(username) {
    const response = await apiInstance.get(
      `${BASE_PATH}/check-username/${username}`
    );
    return response.data;
  },

  async getList() {
    const response = await apiInstance.get(`${BASE_PATH}`);
    return response.data;
  },

  async getDetail(accountId) {
    const response = await apiInstance.get(`${BASE_PATH}/${accountId}`);
    return response.data;
  },

  async create(data) {
    const response = await apiInstance.post(`${BASE_PATH}`, data);
    return response.data;
  },

  async update(accountId, data) {
    const response = await apiInstance.put(`${BASE_PATH}/${accountId}`, data);
    return response.data;
  },

  async delete(accountId) {
    const response = await apiInstance.delete(`${BASE_PATH}/${accountId}`);
    return response.data;
  },

  async resetPassword(accountId) {
    const response = await apiInstance.post(
      `${BASE_PATH}/${accountId}/reset-password`
    );
    return response.data;
  },

  // 2차 인증 초기화: 휴대폰·이메일 수단을 지움 (SPEC-SENDCERT-001 design.md §6-2 B1')
  async resetTwoFactor(accountId) {
    const response = await apiInstance.delete(
      `/accounts/${accountId}/two-factor`
    );
    return response.data;
  },

  // isCompanyManager·mfa.companyRequired 를 읽음 (design.md §5-3)
  async getProfile() {
    const response = await apiInstance.get("/auth/profile");
    return response.data;
  },
};

export default subAccountService;
